import { UnscheduledSectionsQuery } from '../../queries/unscheduled_sections_query';
import { SchedulerModel } from '../../../course_scheduler/models/scheduler_model';
import * as _4 from 'lodash4';
import { ICourse } from '../../../../interfaces/scheduler_interfaces';
import { ITermCoursesDatasource } from '../../../term_courses/datasources/term_courses_datasource';
import { CommunicatorService } from 'ui-ng-component-communicator';
import { TermScheduleFlags } from '../../../course_scheduler/services/term_schedule_flags';
import { SectionFiltersQuery } from '../../../../components/section_filters/queries/section_filters_query';
import { ICommand } from 'core-ts-types';
import { ClearSwapToSectionsCommand } from '../../../../swap/commands/clear_swap_to_sections_command';
import { SchedulerNotificationServant } from '../../../course_scheduler/servants/scheduler_notification_servant';
import { RegistrationAlertMessages } from '../../../course_scheduler/types/registration_alert_messages';
import { SectionSwapServant } from '../../../../swap/servants/section_swap_servant';

export class UnscheduledSections {
  private sectionsFilter: string;
  private course: ICourse | {};
  private tabWidgetIndex = ['available', 'conflicting', 'full'];
  private isInSwapMode: boolean = false;
  private showBackToPlannedCoursesLink: boolean = true;
  private isFiltersOpened: boolean = false;

  private noTimesAvailableCustomMessage: string =
    'No times available. Times are not yet loaded for this course. Check back soon.';
  private showSeatsUpdateMessage: boolean = false;
  private isUpdating: boolean = false;
  private isLoadingSections: boolean = true;
  private updateTimeout: any;
  constructor(
    private $stateParams: ng.ui.IStateParamsService,
    private $state: ng.ui.IStateService,
    private ngTermCoursesDatasource: ITermCoursesDatasource,
    private $timeout: ng.ITimeoutService,
    private ngUnscheduledSectionsQuery: UnscheduledSectionsQuery,
    private ngSectionFiltersQuery: SectionFiltersQuery,
    private ngSchedulerModel: SchedulerModel,
    private ngComponentCommunicatorService: CommunicatorService,
    private clearSectionFiltersCommand: ICommand,
    private clearSwapToSectionsCommand: ClearSwapToSectionsCommand,
    private ngTermScheduleFlags: TermScheduleFlags,
    private ngSchedulerNotificationServant: SchedulerNotificationServant,
    private ngSectionSwapServant: SectionSwapServant
  ) {
    this.sectionsFilter = 'available';
  }

  $onInit() {
    const SMOOTH_TRANSITION_DISMISS = 3000; // 3sec
    const WAIT_TIME_FOR_CALLBACK = 20000; // 20sec
    this.noTimesAvailableCustomMessage = _4.get(
      this.ngSchedulerModel.read(),
      'customtext.NO_TIMES_AVAILABLE.text',
      'No times available. Times are not yet loaded for this course. Check back soon.'
    );
    this.course = this.ngTermCoursesDatasource.get(parseInt(this.$stateParams.courseId, 10)) || {};
    this.isLoadingSections = true;
    this.ngComponentCommunicatorService.subscribe('SECTIONS_LOADED', () => {
      this.isLoadingSections = false;
    });
    this.isInSwapMode = this.ngSectionSwapServant.isInSwapMode();
    if (this.isInSwapMode) {
      this.showBackToPlannedCoursesLink = this.$stateParams.swapCourse === 'true';
    }

    if (this.ngTermScheduleFlags.isOneClickRegistrationEnabled()) {
      this.showSeatsUpdateMessage = true;
      this.isUpdating = true;
      this.ngSchedulerNotificationServant.showInfoNotification(
        RegistrationAlertMessages.PENDING_REFRESH_SECTION_AVAILABILITY_TEXT
      );
      const autoDismissTimer = this.$timeout(() => {
        this.showSeatsUpdateMessage = false;
      }, WAIT_TIME_FOR_CALLBACK);
      this.ngComponentCommunicatorService.subscribe('SEATS_INFO_UPDATED', () => {
        this.showRefreshSectionAvailabilitySuccessNotificationOnce();
        this.isUpdating = false;
        this.updateTimeout = this.$timeout(() => {
          this.showSeatsUpdateMessage = false;
          this.$timeout.cancel(autoDismissTimer);
        }, SMOOTH_TRANSITION_DISMISS);
      });
    }
  }

  showRefreshSectionAvailabilitySuccessNotificationOnce() {
    if (this.isUpdating) {
      this.ngSchedulerNotificationServant.closeCurrentNotification();
      this.ngSchedulerNotificationServant.showSuccessNotification(
        RegistrationAlertMessages.SUCCESSFUL_REFRESH_SECTION_AVAILABILITY_TEXT
      );
    }
  }

  gotoPlannedCourses() {
    if (!this.isInSwapMode) {
      return this.$state.go('my.schedule.registration');
    }

    return this.clearSwapToSectionsCommand().then(() => {
      const previousState = this.ngSectionSwapServant.getPreviousSwapState(this.$stateParams.swapCourse);

      this.$state.go(previousState, {
        courseId: this.$stateParams.courseId,
        sectionTypeId: this.$stateParams.sectionTypeId,
        ignoreConflicts: true,
        swapCourse: this.$stateParams.swapCourse
      });
    });
  }

  dismissUpdateAlert() {
    if (this.updateTimeout) {
      this.$timeout.cancel(this.updateTimeout);
    }
    this.showSeatsUpdateMessage = false;
  }

  gotoConflictingTab() {
    const el = document.getElementById('unscheduled-section-tab-group');
    if (el) {
      el.setAttribute('selected-index', '1');
    }
  }

  toggleTab(event: any) {
    return (this.sectionsFilter = this.tabWidgetIndex[event.target.selectedIndex]);
  }

  noTimesAvailable() {
    const areNoTimesAvailable =
      this.ngUnscheduledSectionsQuery.result.full.length === 0 &&
      this.ngUnscheduledSectionsQuery.result.conflicting.length === 0 &&
      this.ngUnscheduledSectionsQuery.result.available.length === 0;
    const noSections = !this.isLoadingSections && areNoTimesAvailable;
    if (noSections) {
      this.showSeatsUpdateMessage = false;
    }
    return noSections;
  }

  openFilters() {
    this.isFiltersOpened = true;
  }

  clearSectionFilters() {
    this.clearSectionFiltersCommand();
  }
}

class UnscheduledSectionsComponent implements ng.IComponentOptions {
  public bindings: any;
  public controller: any;
  public templateUrl: string;
  constructor() {
    this.controller = UnscheduledSections;
    this.bindings = {};
    this.templateUrl =
      'capability-ng-scheduler/src/views/unscheduled_sections/components/unscheduled_sections/unscheduled_sections.html';
  }
}
angular.module('capability-ng-scheduler').component('unscheduledSections', new UnscheduledSectionsComponent());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/unscheduled_sections/components/unscheduled_sections/unscheduled_sections.ts